<!-- ----------------------------------------------- -->
<template>
  <v-card light class="area-search-card com-popup">
    <v-row class="com-popup-header">
      <span class="com-popup-title">{{ text.aSTitle }}</span>
      <v-spacer></v-spacer>
      <v-btn icon x-small @click="closeAreaSearch">
        <v-icon color="white">highlight_off</v-icon>
      </v-btn>
    </v-row>
    <v-col class="area-search-contents com-popup-contents">
      <div class="area-search-result">
        <v-form ref="form" @submit.prevent>
          <v-container class="pa-0 pl-3">
            <v-row class="pl-3 mr-0" v-show="showCurrentLocationBtn">
              <v-col cols="4" class="pa-0">
                <v-btn
                  small
                  :color="currentLocationBtnColor"
                  class="mt-2 ml-2"
                  @click="moveCurrentLocation()"
                >
                  <v-icon left>my_location</v-icon>
                  <span>{{ text.currentLocation }}</span>
                </v-btn>
              </v-col>
              <v-col cols="8" class="pa-0">
                <div
                  v-if="getCurrentLocationErrorFlag"
                  class="get-location-error-message pt-3"
                >
                  {{ messageConfig.currentLocationError }}
                </div>
              </v-col>
            </v-row>
            <v-row
              v-for="[key, value] in Array.from(pointRegistList)"
              :key="key"
              align="center"
              class="ml-3 mr-0"
            >
              <v-col cols="8" sm="9" class="pa-0">
                <v-text-field
                  v-if="value.center"
                  readonly
                  :value="value.name + '(' + value.address + ')'"
                  class="point-list"
                ></v-text-field>
              </v-col>
              <v-col cols="4" sm="3" class="pa-0">
                <v-btn
                  v-if="value.center"
                  outlined
                  small
                  color="success"
                  class="ml-4"
                  @click="jumpPointRegist(key)"
                >
                  <v-icon left>house</v-icon>
                  <span>{{ text.move }}</span>
                </v-btn>
              </v-col>
            </v-row>
            <v-divider class="mb-2 mr-2"></v-divider>
            <v-row align="center" class="ml-3 mr-0">
              <v-col cols="8" sm="9" class="pa-0">
                <v-text-field
                  v-model="searchWord"
                  :rules="[
                    cityRules.required,
                    cityRules.noSlash,
                    cityRules.noDot,
                  ]"
                  :placeholder="text.searchEntry"
                  v-on:keyup.enter="searchAddress"
                  clearable
                  clear-icon="cancel"
                  class="search-word pt-0"
                ></v-text-field>
              </v-col>
              <v-col cols="4" sm="3" class="pa-0">
                <v-btn
                  outlined
                  small
                  color="success"
                  :loading="addressSearchStatus === 2"
                  :disabled="addressSearchStatus === 2 || !checkSearchWord()"
                  class="ml-4"
                  @click="searchAddress()"
                >
                  <v-icon left>search</v-icon>
                  <span>{{ text.search }}</span>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
        <v-col v-show="addressSearchStatus === 3" class="pa-0">
          <v-col class="pa-0">
            <v-divider class="mt-0 mb-0"></v-divider>
            <v-tabs v-model="tabIndex" height="40">
              <v-tab>{{ text.cityName }}</v-tab>
              <v-tab>{{ text.postalCode }}</v-tab>
              <v-tab>{{ text.areaCode }}</v-tab>
            </v-tabs>
          </v-col>
          <v-col
            class="area-search-result-list pt-0 pb-0"
            v-if="tabIndex === 0"
          >
            <v-list
              v-if="
                addressSearchResultsInfo.cityNameSearchResults &&
                  addressSearchResultsInfo.cityNameSearchResults.length > 0
              "
              class="pt-0 pb-0"
            >
              <v-list-item-group color="primary">
                <div
                  v-for="(item,
                  index) in addressSearchResultsInfo.cityNameSearchResults"
                  :key="index"
                >
                  <v-list-item
                    @click="jumpResultsLocation(item.twnCd)"
                    class="area-search-result-item"
                  >
                    <v-list-item-content class="pt-0 pb-0">
                      <v-list-item-title
                        v-text="getResultString(item)"
                      ></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider></v-divider>
                </div>
              </v-list-item-group>
            </v-list>
            <span v-else>{{ text.noSearchResults }}</span>
          </v-col>
          <v-col
            class="area-search-result-list pt-0 pb-0"
            v-if="tabIndex === 1"
          >
            <v-list
              v-if="
                addressSearchResultsInfo.postalCodeSearchResults &&
                  addressSearchResultsInfo.postalCodeSearchResults.length > 0
              "
              class="pt-0 pb-0"
            >
              <v-list-item-group color="primary">
                <div
                  v-for="(item,
                  index) in addressSearchResultsInfo.postalCodeSearchResults"
                  :key="index"
                >
                  <v-list-item
                    @click="jumpResultsLocation(item.twnCd)"
                    class="area-search-result-item"
                  >
                    <v-list-item-content class="pt-0 pb-0">
                      <v-list-item-title
                        v-text="getResultString(item)"
                      ></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider></v-divider>
                </div>
              </v-list-item-group>
            </v-list>
            <span v-else>{{ text.noSearchResults }}</span>
          </v-col>
          <v-col
            class="area-search-result-list pt-0 pb-0"
            v-if="tabIndex === 2"
          >
            <v-list
              v-if="
                addressSearchResultsInfo.areaCordSearchResults &&
                  addressSearchResultsInfo.areaCordSearchResults.length > 0
              "
              class="pt-0 pb-0"
            >
              <v-list-item-group color="primary">
                <div
                  v-for="(item,
                  index) in addressSearchResultsInfo.areaCordSearchResults"
                  :key="index"
                >
                  <v-list-item
                    @click="jumpResultsLocation(item.twnCd)"
                    class="area-search-result-item"
                  >
                    <v-list-item-content class="pt-0 pb-0">
                      <v-list-item-title
                        v-text="getResultString(item)"
                      ></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider></v-divider>
                </div>
              </v-list-item-group>
            </v-list>
            <span v-else>{{ text.noSearchResults }}</span>
          </v-col>
        </v-col>
      </div>
    </v-col>
  </v-card>
</template>
<!-- ----------------------------------------------- -->
<script>
import mixin from "../../lib/mixin.js";
import PageLog from "../../lib/pageLog.js";

/**
 * 川の防災情報 地図画面 住所検索ダイアログ
 * AreaSearch.vue
 * @author LIS
 */
export default {
  name: "map-area-search",
  mixins: [mixin],
  data() {
    return {
      /** 文字列リソース */
      text: {
        aSTitle: "市町村名検索",
        currentLocation: "現在位置取得",
        move: "移動",
        search: "検索",
        searchEntry: "検索ワードを入力してください",
        cityName: "市町村名",
        postalCode: "郵便番号",
        areaCode: "市外局番",
        noSearchResults: "該当の地域はありません。",
      },
      /** 市町村名、郵便番号、市外局番で検索 */
      cityRules: {
        required: (value) => !!value || "検索ワードは1文字以上入力してください",
        noSlash: (value) =>
          !value.match(/\//) || '"/"は検索ワードに含めることはできません',
        noDot: (value) =>
          !value.match(/\./) || '"."は検索ワードに含めることはできません',
      },
      /** 検索ワード */
      searchWord: "",
      /** 住所検索結果タブ設定 */
      tabIndex: 0,
    };
  },
  computed: {
    /** メッセージ情報 */
    messageConfig: {
      get() {
        return this.$store.state.app.config.messageConfig;
      },
    },
    /** 住所検索ダイアログ表示状態 */
    visibility: {
      get() {
        return this.$store.state.map.showAreaSearch;
      },
    },
    /** 地点登録リスト */
    pointRegistList: {
      get() {
        return this.$store.state.map.point;
      },
    },
    /** 住所検索結果 */
    addressSearchResultsInfo: {
      get() {
        return this.$store.state.map.addressSearchResultsInfo;
      },
    },
    /** 住所検索状態 */
    addressSearchStatus: {
      get() {
        return this.$store.state.map.addressSearchStatus;
      },
    },
    /** 現在位置取得ボタン色設定 */
    currentLocationBtnColor: {
      get() {
        if (this.$store.state.map.currentLocationFlag) {
          return "accent";
        }
        return "success";
      },
    },
    /** 現在位置取得ボタン表示設定 */
    showCurrentLocationBtn: {
      get() {
        if (this.$store.state.app.mode == "pc") {
          return true;
        }
        return false;
      },
    },
    /** 現在位置情報取得エラーフラグ */
    getCurrentLocationErrorFlag: {
      get() {
        return this.$store.state.map.currentLocationErrorFlag;
      },
    },
  },
  methods: {
    /** 住所検索ダイアログの非表示 */
    closeAreaSearch() {
      this.$store.commit("map/setShowAreaSearch", false);
    },
    /** 現在位置取得・移動 */
    moveCurrentLocation() {
      if (!this.$store.state.map.currentLocationFlag) {
        // アクセスログ出力
        PageLog.log({
          page_log: "gps",
          device_sb: this.$store.state.app.mode,
          fc_flg: this.$store.getters["app/isFldCtl"],
        });
      }
      this.$store.dispatch("map/moveCurrentLocation", "pc");
    },
    /** 登録地点に移動 */
    jumpPointRegist(key) {
      this.$store.dispatch("map/moveMapPoint", {
        latLng: this.$store.state.map.point.get(key).center,
        flyto: true,
      });
      this.$store.commit("map/setShowAreaSearch", false);

      // 登録地点情報画面へ遷移
      this.$store.commit("map/setSelectPointIndex", key - 1);
      if (this.$store.state.app.mode == "pc") {
        this.routerPushPoint("/pc/rp");
      } else {
        this.routerPushPoint("/mb/rp");
      }
    },
    /** 住所検索ボタン押下時の処理 */
    searchAddress() {
      // 検索ワードエラーの場合は検索を実施しない
      if (this.checkSearchWord()) {
        this.$refs.form.resetValidation();
        // 検索回数をインクリメント
        this.$store.commit("map/incrementSearchNum");
        // 住所検索
        this.$store.dispatch("map/getAddressSearchResults", {
          searchWord: this.searchWord,
          deviceSb: this.$store.state.app.mode,
          fcFlg: this.$store.getters["app/isFldCtl"],
        });
      }
    },
    /** 住所検索結果クリック時の処理 */
    jumpResultsLocation(twnCd) {
      // クリックした住所検索結果の座標に移動
      this.$store.dispatch("map/moveMapCity", twnCd);
      this.$store.commit("map/setShowAreaSearch", false);
    },
    /** 検索結果文字列生成 */
    getResultString(result) {
      return result.prefNm + " " + result.twnNm;
    },
    /** 検索ワードチェック */
    checkSearchWord() {
      if (
        this.cityRules.required(this.searchWord) == true &&
        this.cityRules.noSlash(this.searchWord) == true &&
        this.cityRules.noDot(this.searchWord) == true
      ) {
        return true;
      }
      return false;
    },
  },
  watch: {
    /** 住所検索ダイアログ表示状態監視 */
    visibility() {
      this.$refs.form.resetValidation();
      this.$store.commit("map/setCurrentLocationErrorFlag", false);
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped>
@import "./../../scss/color.scss";
.area-search-card {
  position: absolute;
  z-index: 3030;
  top: 4px;
  left: 4px;
  width: 480px;
  max-height: calc(100% - 8px);
  max-width: calc(100% - 8px);
  min-height: 30vh;
  .area-search-contents {
    min-height: 50vh;
    height: 100%;
    position: relative;
    .area-search-result {
      height: calc(100% - 4px);
      overflow-y: auto;
      top: 0px;
      left: 0px;
      right: 0px;
      bottom: 0px;
      position: absolute;
      .get-location-error-message {
        color: $color-error-message;
        font-size: 0.8rem;
      }
      .point-list {
        font-size: 0.8rem;
        padding: 0;
      }
      .search-word {
        font-size: 0.8rem;
        ::placeholder {
          color: #e93838;
        }
      }
      .area-search-result-list {
        max-height: 245px;
        min-height: 100px;
        .area-search-result-item {
          min-height: 40px;
        }
      }
    }
  }
}
</style>
